import { useCallback } from "react";
import { DndProvider } from "react-dnd";
import { HTML5Backend } from "react-dnd-html5-backend";
import { FieldListItem } from "./FieldListItem";
import { DraftTemplateField } from "../../models/workPaperTemplate";

interface TemplateFieldListProps {
  fields: DraftTemplateField[];
  onEdit: (fieldId: string) => void;
  onDelete: (fieldId: string) => void;
  onReorder: (newOrder: string[]) => void;
  readOnly?: boolean;
}

export function TemplateFieldList({
  fields,
  onEdit,
  onDelete,
  onReorder,
  readOnly = false,
}: TemplateFieldListProps) {
  const activeFields = fields.filter((f) => !f.isDeleted);

  const handleMove = useCallback(
    (dragIndex: number, hoverIndex: number) => {
      const dragField = activeFields[dragIndex];
      const newFields = [...activeFields];
      newFields.splice(dragIndex, 1);
      newFields.splice(hoverIndex, 0, dragField);
      onReorder(newFields.map((f) => f.id));
    },
    [activeFields, onReorder],
  );

  if (activeFields.length === 0) {
    return (
      <div className="border-2 border-dashed border-gray-300 rounded-lg p-8 text-center text-gray-500">
        No fields added yet. Click "Add Field" to get started.
      </div>
    );
  }

  return (
    <DndProvider backend={HTML5Backend}>
      <div className="space-y-2">
        {activeFields.map((field, index) => (
          <FieldListItem
            key={field.id}
            field={field}
            index={index}
            onEdit={() => onEdit(field.id)}
            onDelete={() => onDelete(field.id)}
            onMove={handleMove}
            readOnly={readOnly}
          />
        ))}
      </div>
    </DndProvider>
  );
}
